export const ENTER_EMAIL_TO_SAVE_MODAL = {
  title: 'Pick up where <span>you left off!</span>',
  email_input: 'Email',
  save_button: 'Save your progress',
  dont_save_button: "I DON'T WANT TO SAVE",
  become_belong_member: 'Become a Belong Member! ',
  sign_up_button: 'SIGN UP',
};
